<template>
<!---Old Design--->
  <header class="pos-header" :style="routeName ==='/pos-fnb-login' ? 'padding-left:10px;' : ''">
    <div class="row col-12">
      <div class="align-self-center d-flex">
        <span :class="routeName ==='/pos-fnb-login' ? 'mr-0' : 'mr-5'">
          <img
            src="@/assets/img/logos/logo-dark.png"
            width="60"
            v-if="routeName !== '/pos-fnb-login'"
            height="auto"
            alt
          />
        </span>
        <!-- <img :src="orgURL" alt="Organization Logo" width="55" height="50" /> -->
        <div
          class="align-self-center"
          v-if="routeName !== '/pos-fnb-cash-input'"
        >
          <div
            v-if="accessLimitation == 'SUPER'"
            class="pos-tabs"
          >
            <router-link to @click.native.prevent="onSwitchToBoxOffice()"
              >POS</router-link
            >
            <router-link to class="active">FNB</router-link>
          </div>
        </div>
      </div>
      <!-- Add-ons-modal -->
      <b-modal hide-footer size="lg" id="add-ons-modal" title="Add Ons">
        <div>
          <div class="row text-uppercase font-weight-bold pb-2 border-bottom">
            <div class="col-8">
              <span class="px-3">ITEM</span>
            </div>
            <div class="col-2">
              <span>PRICE</span>
            </div>
            <div class="col-2 text-right">
              <span class="px-3">ACTION</span>
            </div>
          </div>
          <div class="row mx-0">
            <div
              class="col-12 py-3 border-bottom"
              v-for="(addOn, addOnIndex) in addOnsList"
              :key="addOnIndex"
            >
              <div class="row">
                <div class="col-8 align-self-center">
                  <span class="font-weight-semi-bold">{{
                    addOn.add_on_item_name
                  }}</span>
                </div>
                <div class="col-2 align-self-center">
                  <span class="font-weight-semi-bold"
                    >{{ getFnBCurrency && getFnBCurrency.curr_code }}&nbsp;{{
                      addOn.add_on_item_price | RoundOff
                    }}</span
                  >
                </div>
                <div class="col-2">
                  <button
                    @click="onSelectAddon(addOn)"
                    class="btn-outline-blue mx-0"
                  >
                    Add
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
      <!-- modal ends -->
      <div class=" d-flex align-items-center justify-content-end" style="height:50px">

        <!-- <div
          class="d-flex flex-column mr-3 text-center"
          style="line-height: 1; min-width: 117px;"
        >
          <span> Version </span>
          <span> {{ semver }} </span>
        </div>
        <div
          class="d-flex flex-column mr-3 text-center"
          style="line-height: 1; min-width: 117px;"
        >
          <span> Release </span>
          <span> {{ releaseVersion }} </span>
        </div> -->
        <!-- <div class="d-flex mr-3 text-nowrap" v-if="DeviceUniqueCode || routeName !== '/pos-fnb-login'">
          <div class="mx-2 text-blue">Device - {{ DeviceUniqueCode }}</div>
        </div> -->
        <!-- <div class="d-flex mr-2">
          <div class="mx-2 text-blue">{{ CinemaName }}</div>
        </div> -->

        <div class="d-flex mr-3 text-nowrap" v-if="routeName !== '/pos-fnb-login'">
          <div class="mx-2 text-blue">{{ currentDate }}</div>
          <div>|</div>
          <div class="mx-2">{{ currentTime }}</div>
        </div>

        <b-dropdown right variant="pos-dropdown" class="mr-3" v-if="routeName !== '/pos-fnb-login'">
          <template v-slot:button-content>
            <img
              src="@/assets/img/icons/language-icon.svg"
              height="25px"
              width="25px"
            />
            <span>{{ selectedLanguage }}</span>
          </template>
          <div v-for="(language, index) in languages" :key="index">
            <b-dropdown-item @click="changeLanguage(language)">{{
              language.title
            }}</b-dropdown-item>
            <b-dropdown-divider
              v-if="languages.length - 1 == !index"
            ></b-dropdown-divider>
          </div>
        </b-dropdown>

        <!-- ORG LOGO -->
        <div class="d-flex mr-3" v-if="routeName !== '/pos-fnb-login'">
          <div class="">
            <img
              :src="getOrganizationDetails.org_logo_url"
              height="auto"
              width="100"
              class="mx-2"
            />
          </div>
        </div>
        <!-- ORG LOGO END -->

        <b-dropdown
          v-if="USERLOCATIONS.length > 0 && token"
          right
          class="pos-header-dropdown"
          variant="pos-dropdown"
        >
          <template v-slot:button-content >
            <span >{{ getUserLocation() }}</span>
          </template>
          <template>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item :class="selectedPosUserId == users.user_id ? 'disableLocation' : ''" :disabled="selectedPosUserId == users.user_id" :key="userIndex" v-for="(users, userIndex) in USERLOCATIONS" @click="OnChangeUserLocation(users)">
              {{users.cine_name}}
              <div class="text-muted fs-10 p-0 m-0">{{users.first_name}}&nbsp;{{users.last_name ? users.last_name : ''}}<span v-if="selectedPosUserId == users.user_id" class="font-italic">&nbsp;(Logged)</span></div>
              </b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
          </template>
        </b-dropdown>

        <b-dropdown
          v-if="token"
          right
          class="pos-header-dropdown positioning-header"
          variant="pos-dropdown"
          @show="onCheckShift()"

        >
          <template  v-slot:button-content >
            <img src="@/assets/img/icons/user-profile.svg" style="width:40px"/>
            <!-- <span >{{ getUSINFO() }}</span> -->
          </template>
          <!-- <b-dropdown-item href="#">Settings</b-dropdown-item> -->
          <template v-if="!loading">
            <b-dropdown-divider></b-dropdown-divider>



            <b-dropdown-item @click="lockScreen()"
              >Lock Screen</b-dropdown-item
            >
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item
              v-if="
                !isLogin &&
                  GetCinemaShiftIsActive &&
                  GetCinemaShiftIsActive === 'Y' &&
                  shiftRunning
              "
              v-on:click="onClickModal()"
              >Close Shift</b-dropdown-item
            >
            <b-dropdown-divider
              v-if="
                !isLogin &&
                  GetCinemaShiftIsActive &&
                  GetCinemaShiftIsActive === 'Y' &&
                  shiftRunning
              "
            ></b-dropdown-divider>
            <!-- <b-dropdown-item v-if="isLogin" v-on:click="onLogout()">Logout</b-dropdown-item> -->
            <b-dropdown-item v-on:click="configureSetting()">Settings</b-dropdown-item>
            <b-dropdown-item v-on:click="onLogout()">Logout</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>


      <b-dropdown-item>
           <!-- {{ semver }} -->
           <span>
           {{ releaseVersion }}
           </span>

          </b-dropdown-item>
        <b-dropdown-divider v-if="DeviceUniqueCode"></b-dropdown-divider>
              <b-dropdown-item v-if="DeviceUniqueCode">
                <!---Device Name-->
                <div class="d-flex mr-3 text-nowrap">
                  <div class="text-blue">Device - {{ DeviceUniqueCode }}</div>
                </div>
                <!---Device Name-->
              </b-dropdown-item>


          </template>
          <div v-else>
            <div class="loader"></div>
          </div>
        </b-dropdown>
      </div>
    </div>
     <b-modal
      id="confirmation_active_inactive"
      title="Confirmation"
      hide-footer
      hide-header
      centered
    >
      <div class="text-center pb-1 my-3">
        <p class="fs-16 mb-3">Do you want to Close Your Shift ? </p>
        <span class="mx-1"></span>
        <button
          class="btn btn-success btn-success-lg px-4 fs-14"
          v-on:click="onCloseShift()"
        >
          Yes
        </button>

         <button
          class="btn-outline-blue"
          @click.prevent.stop="$bvModal.hide('confirmation_active_inactive')"
        >
          Cancel
        </button>
      </div>
    </b-modal>
    <PosSettingsPopup/>
    <ManagerAuthLogin :moduleName="'closeShiftAuth'" :onCheckAuth="onCheckAuthentication" :refId="'closeShiftAuth'" />
  </header>
  <!---Old Design--->


</template>

<script>
import languages from "@/helper/Languages";
import i18n from "@/plugins/i18n";
import PosService from "@/services/PosService";
import { BASEURL } from "@/config/index";
import { backendSocket } from "@/main.js";
import PosSettingsPopup from "@/components/Partials/PosSettingsPopup.vue";
import moment from "moment";
import ManagerAuthLogin from "@/components/Partials/AuthManagerLoginPopup";
import { Role, CLIENT_NAME } from "@/helper/Role";


export default {
   components: {
    PosSettingsPopup,
    ManagerAuthLogin,
  },
  props: {
    isLogin: {
      type: Boolean,
      default: false
    },
    onClickHandler: { type: Function },
  },
  data() {
    return {
      accessLimitation: '',
      selectedPosUser: '',
      selectedPosUserId: null,
      USERLOCATIONS: [],
      token: null,
      shiftRunning: false,
      loading: true,
      noAuth: false,
      languages,
      orgURL: "",
      URL_BASE: BASEURL,
      selectedLanguage: "English",
      hardware_id: "",
      DeviceUniqueCode: ""
    };
  },
  sockets: {
    hardwareId: function(macId) {
      if (macId) {
        this.hardware_id = macId;
      }
    }
  },
  computed: {
    semver() {
      return 'V 1.0.0'
    },
    MANAGER_AUTH_FOR_CHANGES() {
      return this.$store.getters.MANAGER_AUTH_FOR_CHANGES
    },
     selectedUserLocation() {
       return this.secureStore.get("USINFO").cine_name
    },
     GetCinemaShiftIsActive() {
      return this.secureStore.get("BRCISH");
    },
    releaseVersion() {
      return '03-Jan-22-18:00'
    },
    CinemaName() {
      return (
        this.secureStore.get("USINFO") &&
        this.secureStore.get("USINFO").cine_name
      );
    },
    getOrganizationDetails() {
      return this.$store.getters.getOrganizationDetails;
    },
    USE_TIM_INTEGRATION() {
      return this.$store.getters.USE_TIM_INTEGRATION;
    },
    getFnBCurrency() {
      return this.$store.getters.getFnBCurrency;
    },
    addOnsList() {
      return this.$store.getters.addOns;
    },
    routeName: function() {
      return this.$route.path;
    },
    currentDate() {
      return this.$store.getters.CURRENT_DATE;
    },
    currentTime() {
      return this.$store.getters.CURRENT_TIME;
    },
    roleId() {
      return this.secureStore.get("USINFO") &&
        this.secureStore.get("USINFO").role_id
        ? this.secureStore.get("USINFO").role_id
        : 0;
    },
    userInfo() {
      return this.secureStore.get("USINFO") &&
        this.secureStore.get("USINFO").first_name &&
        this.secureStore.get("USINFO").last_name
        ? this.secureStore.get("USINFO").first_name +
            " " +
            this.secureStore.get("USINFO").last_name
        : "Admin";
    },
    FnBItemsModule() {
      return this.$store.getters.getFnBItemsModule;
    }
  },
  beforeMount() {
    this.getOrgnizationLogo();
    this.getPosUserLocations();
    this.DeviceUniqueCode = window.localStorage.getItem("deiviceUniqueCode")
      ? window.localStorage.getItem("deiviceUniqueCode")
      : "";
    this.accessLimitation = this.secureStore.get('BRUACS');
  },
  mounted() {
    this.setTime();
    this.updateTime();
    this.token = window.localStorage.getItem("JWT_TOKEN");
    console.log('this.secureStore.get("USINFO")', this.secureStore.get("USINFO"));
  },
  methods: {
    moment,
    onCheckAuthentication(response) {
      const {valid, name} = response
      if(valid) {
        if(name == 'closeShiftAuth') {
          this.$bvModal.hide('closeShiftAuth');
          this.onCloseShift()
        }
      }
    },
     onClickModal() {
      console.log('CLOSE SHIFT Modal Opened');
      if( CLIENT_NAME.IRAQ == this.CLIENT_SETUP_NAME ) {
        if(this.MANAGER_AUTH_FOR_CHANGES == 'Y') {
          this.$bvModal.show('closeShiftAuth');
        } else {
          this.$bvModal.show('confirmation_active_inactive')
        }
      } else {
        this.$bvModal.show('confirmation_active_inactive')
      }
    },
    getUSINFO() {
      let text = `Admin`
      let loggedUser = this.secureStore.get("USINFO")
      text = loggedUser.first_name + (loggedUser.last_name ? ' ' + loggedUser.last_name : '')
      return text
    },
     lockScreen() {
      window.localStorage.setItem("LockedSinced", moment().format("HH:mm:ss"));
      window.localStorage.setItem("Locked", true);
      this.$store.dispatch("onSetAndSendLog", {
        action: `User Locked the Screen`
      });
      console.log("time", moment().format("HH:mm:ss"));
      this.$router.push({
        path: "pos-lock-screen"
      });
    },
     configureSetting() {
      this.$bvModal.show('posSettingsModal')
    },
    getUserLocation() {
       return this.secureStore.get("USINFO").cine_name
    },
     OnChangeUserLocation(user) {
      let payload = {
        dflt_user_id: this.secureStore.get("DFLT_USINFO").user_id,
        new_user_id: user.user_id
      }

      PosService.changeLoggedUserCinema(payload).then(async (response) => {
        const {data} = response;
        console.log('data', data);
        let finalObj = {};
        let PromiseArray = this.usersArray.map(x => {
          finalObj[x] = data.data.user[x] || null;
        });
        console.log('finalObj', finalObj);
        await Promise.all(PromiseArray);

         if (data.data.user && data.data.user.shift_id) {

                this.secureStore.set("USINFO", finalObj);

                this.$cookie.set("BRHSID", data.data.token, {
                  expires: "1Y"
                });

                this.$store.dispatch("onSetAndSendLog", {
                  cinema_id: finalObj.cinema_id,
                  user_id: finalObj.user_id,
                  action: "POS User Logged In",
                  page_name: "POS LOGIN",
                  api_name: window.location.hash
                });

                this.$cookie.set("BRLF", "pos-login");
                window.localStorage.setItem("JWT_TOKEN", data.data.token);

                this.secureStore.set(
                  "BRCISH",
                  data.data.user.cine_include_shift_close
                );

                this.secureStore.set(
                  "BRCIFTAT",
                  data.data.user["cine_include_float_amount"]
                );

                this.$store.dispatch("userShiftStart", {
                  page_name: "FNB_LOGIN",
                  usl_id: data.data.user.user_id,
                  user_shift_id: data.data.user.shift_id,
                  cine_include_shift_close:
                    data.data.user.cine_include_shift_close,
                  cine_include_float_amount:
                    data.data.user.cine_include_float_amount
                });

                var userAgent = navigator.userAgent.toLowerCase();

                if (userAgent.indexOf(" electron/") > -1) {
                  if (backendSocket && backendSocket.connected) {
                    backendSocket.emit("on_user_login", {
                      user: data.data.user,
                      hardware_id: this.hardware_id
                    });
                  }
                }
                this.selectedPosUserId = user.user_id,
                this.selectedPosUser = user;
                this.onClickHandler('Refresh');
                // location.reload();
              } else {
                this.$toasted.show(
                  "Shift is Not Created For Selected Location"
                );
              }
      }).catch((err) => {
        console.log('Error:', err);
      })
    },
    getPosUserLocations() {
      let payload = {
        user_id: this.secureStore.get("DFLT_USINFO").user_id
      }
      PosService.GetPosLocationsUsers(payload).then((response) => {
        const {data} = response;
        if(data && data.status && data.Records && data.Records.length > 0) {
          this.USERLOCATIONS = data.Records
          let loggedUserid = this.secureStore.get("USINFO").user_id;
          let loggedUser = this.USERLOCATIONS.find((x) => loggedUserid == x.user_id);
          if(loggedUser) {
            this.selectedPosUserId = loggedUser.user_id;
            this.selectedPosUser = loggedUser;
          }
        } else {
          this.USERLOCATIONS = [];
        }
        console.log('this.USERLOCATIONS', this.USERLOCATIONS);
      }).catch((err) => {
        console.log('ERROR:', err);
      })
    },

    onCheckShift: function() {
      this.loading = true;
      PosService.shiftChecker().then(response => {
        const { data } = response;
        this.loading = false;
        if (data.status) {
          this.shiftRunning = data.shiftRunning;
        } else {
          this.shiftRunning = true;
        }
      });
    },
    getOrgnizationLogo: function() {
      // function checkImage(imageSrc, good, bad) {
      // var img = new Image();
      // img.onload = good;
      // img.onerror = bad;
      // img.src = imageSrc;
      // }
      PosService.getOrgDetails()
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            // checkImage(BASE_URL+data.Records[0].org_logo_url, function(){ alert("good"); }, function(){ alert("bad"); })
            this.orgURL = data.Records[0].org_logo_url;
            if (this.$socket) {
              this.$socket.emit("set_org_details", data.Records[0]);
            }
          } else {
            // this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    updateTime: function() {
      let self = this;
      setInterval(function() {
        self.setTime();
      }, 60000);
    },

    setTime: function() {
      this.$store.dispatch("SET_CURRENT_TIME");
    },
   closeEftSession() {
      localStorage.setItem('ECR_INIT_STATUS', false)
      // if(typeof balance == 'function') {
      //    balance();
      // }

      if(typeof deactivate == 'function') {
        setTimeout(() => {
          deactivate();
        }, 1500);
      }
    },
    onCloseShift: function() {
      this.$store.dispatch("onResetFnBStoreState");
      this.$store.dispatch("onResetDateStoreState");
      this.$store.dispatch("MAKE_DATA_EMPTY");
      this.closeEftSession()
      this.$router.push({
        path: "close-shift"
      });
    },
    onSwitchToBoxOffice: function() {
      let userInfo = this.secureStore.get("USINFO");
      if (userInfo) {
        userInfo["role_name"] = "POS Operator";

        this.secureStore.set("USINFO", userInfo);
        this.$router.push({
          path: "pos-booking"
        });
      } else {
        this.$router.push({
          path: "pos-login"
        });
      }
      this.$store.dispatch("onResetFnBStoreState");
    },
    onLogout: function() {
      this.$store.dispatch("onSetAndSendLog", {
        action: "FNB User Loged out",
        page_name: "FNB booking",
        api_name: window.location.hash
      });
      var userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.indexOf(" electron/") > -1) {
        if (backendSocket && backendSocket.connected) {
          backendSocket.emit("on_user_logout", {
            hardware_id: this.DeviceUniqueCode
          });
        }
      }
      // window.localStorage.removeItem("JWT_TOKEN");
      this.$store.dispatch("onResetFnBStoreState");
      this.$store.dispatch("onResetDateStoreState");
      this.$store.dispatch("MAKE_DATA_EMPTY");

      var myItem = null;
      if(localStorage.getItem('ECR_INFO')) {
        myItem = localStorage.getItem('ECR_INFO');
      }
      window.localStorage.clear();
      if(myItem) {
        localStorage.setItem('ECR_INFO',myItem);
      }

      this.$cookie.delete("BRHSID");
      this.$router.push({
        path: "pos-fnb-login"
      });
    },
    onSelectAddon: function(addOn) {
      this.$store.dispatch("onSelectAddon", addOn);
    }
  }
};
</script>

<style>
.disableLocation {
  opacity: 0.5;
  cursor: not-allowed;
}
.loader {
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 25px;
  height: 25px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
  margin: 0 auto;
  margin-top: 10px;
  margin-bottom: 10px;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.positioning-header{
  position: absolute !important;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/posFnBHeader.vue